module.exports = __webpack_public_path__ + "img/invitation_start.94116cbc.png";